import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-detail_step-mid",
  "use": "icon-detail_step-mid-usage",
  "viewBox": "0 0 155 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 155 32\" id=\"icon-detail_step-mid\"><path d=\"M3.813 0h139.25a2 2 0 011.646.863l9.702 14.043a2 2 0 01-.004 2.278l-9.101 13.098A4 4 0 01142.021 32H3.825a2 2 0 01-1.642-3.141l8.112-11.675a2 2 0 00.003-2.278l-8.13-11.77A2 2 0 013.812 0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol